module.exports = "<app-spare-parts-in-out\n[type] = \"type\"\n[title] = \"title\"\n[isInventory] = \"isInventory\"\n> \n</app-spare-parts-in-out>\n"